import ConnectableSlots, { ConnectableSlotsAndRequiresConnectArticle } from '../ConnectableSlots';
import { SlotMapper } from './SlotMapper';

export class ConnectableSlotsMapper {
  static toDomain = (dto: CoreServiceAPI.ConnectableSlotsDto): ConnectableSlots => ({
    mainSlot: SlotMapper.toDomain(dto.mainSlot),
    blockedSlots: dto.blockedSlots ? dto.blockedSlots.map(SlotMapper.toDomain) : []
  });
}

export class ConnectableSlotsAndRequiresConnectArticleMapper {
  static toDomain = (
    dto: CoreServiceAPI.ConnectableSlotsDto
  ): ConnectableSlotsAndRequiresConnectArticle => ({
    connectableSlots: ConnectableSlotsMapper.toDomain(dto),
    requiresConnectArticle: dto.requiresConnectArticle
  });
}
